import { FC } from "react";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import GameListItem from "./GameListItem";
import { useGameDataContext } from "@context/GameDataContext";
import { useResponsiveContext } from "@context/ResponsiveContext";

const GamesList: FC = () => {
  const { games } = useGameDataContext();
  const { onTablet } = useResponsiveContext();
  return (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: onTablet ? 150 : 650 }} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell>Datum</TableCell>
            <TableCell>Heim</TableCell>
            <TableCell>Gast</TableCell>
            <TableCell />
          </TableRow>
        </TableHead>
        <TableBody>
          {games
            .filter((game) => !game.samsId.startsWith("deleted"))
            .sort(
              (a, b) =>
                b.gameData.gameStartDateTime - a.gameData.gameStartDateTime,
            )
            .map((game) => (
              <GameListItem game={game} />
            ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default GamesList;
